import React from "react";
import { Button, ErrorBlock } from "antd-mobile";

class ErrorBoundary extends React.Component {
  state = {
    errorMessage: "",
  };

  static getDerivedStateFromError(error) {
    return { errorMessage: error.toString() };
  }

  componentDidCatch(error, info) {
    console.log(error.toString(), info.componentStack);
  }

  // A fake logging service.

  render() {
    const handleWebviewEvent = () => {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "reloadApp" })
        );
      }
    };

    if (this.state.errorMessage) {
      return (
        <ErrorBlock
          //   image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
          style={{
            "--image-height": "150px",
          }}
          description={
            <span style={{ padding: "0 24px" }}>
              An unknown error has occurred, please click the button to reload
              the app
            </span>
          }
          fullPage>
          <Button
            color="primary"
            onClick={() => {
              handleWebviewEvent();
              window && window.location.reload();
            }}>
            Refresh App
          </Button>
        </ErrorBlock>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
